/** NOTE : Don;t edit this file, if need to add new environment add it but flow the same structure - 
 * This File is using in pipeline for Automatic deploymement
 **/

/******************************* LOCAL ***************************************/
/***local-start***/
//  export const SERVER_URL = "http://localhost:9091/api-web/v1/";
// export const REACT_APP_SOCKET_CONNECTION_URL = "ws://localhost:9091/api-web/websocket";
// export const REACT_APP_CAPTCHA_KEY="6LezJnApAAAAAFEFpX-fIvhQZ6rCf7PXu2eb1wGe";
/***local-end***/

/******************************* DEV ***************************************/
/***dev-start***/
 export const SERVER_URL="https://dev.pickndrop.ae/api-web/v1/";
 export const REACT_APP_SOCKET_CONNECTION_URL="wss://dev.pickndrop.ae/api-web/websocket";
 export const REACT_APP_CAPTCHA_KEY="6LcRXT0tAAAAAPO8ivNcOhupQXNUgnKUtu75Ctuq";
/***dev-end***/

/******************************* UAT ****************************************/
/***uat-start***/
// 
/***uat-end***/

/******************************* PRODUCTION *********************************/
/***production-start***/
// export const SERVER_URL="https://pickndrop.ae/api-web/v1/";
// export const REACT_APP_SOCKET_CONNECTION_URL="wss://pickndrop.ae/api-web/websocket";
// export const REACT_APP_CAPTCHA_KEY="6Lcec5cqAAAAAPdS7FAGE8OTJJ8l8enSs_W7vINI";
/***production-end***/
